import ReactDOM from 'react-dom';
// Clone ReactDOM object to prevent the `createRoot not found` warning
const ReactDOMCloned = { ...ReactDOM };
function suspendReactDOMClientWarning(suspend) {
    const ReactDOMInternalObject = ReactDOMCloned.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (ReactDOMInternalObject && typeof ReactDOMInternalObject === 'object') {
        ReactDOMInternalObject.usingClientEntryPoint = suspend;
    }
}
/**
 * Create a React root and render React elements into it. For both React 17 and 18.
 */
export function renderToContainer(element, container) {
    // For React v18
    if (Number((ReactDOM.version || '').split('.')[0]) >= 18 &&
        ReactDOMCloned.createRoot) {
        suspendReactDOMClientWarning(true);
        const root = ReactDOMCloned.createRoot(container);
        suspendReactDOMClientWarning(false);
        root.render(element);
        return {
            unmount() {
                root.unmount();
            },
        };
    }
    // For React v17 and older
    /* eslint-disable-next-line react/no-deprecated */
    ReactDOM.render(element, container);
    return {
        unmount() {
            /* eslint-disable-next-line react/no-deprecated */
            ReactDOM.unmountComponentAtNode(container);
        },
    };
}
